import { getLogger } from '@hashnode/file-parsing'
import chalk from 'chalk'
import ora from 'ora'
import { LinkedDocumentationProjectQuery } from '../generated/graphql'
import { getClient } from '../get-client'

const logger = getLogger()

export async function validateLinkedProject(
	linkedProjectId: string,
): Promise<LinkedDocumentationProjectQuery['documentationProject'] | never> {
	const spinner = ora(' Validating linked project... ').start()
	const sdk = getClient()

	try {
		const linkedProject = await sdk.LinkedDocumentationProject({
			documentationProjectId: linkedProjectId,
		})
		if (!linkedProject) {
			spinner.fail(' Unable to validate the linked project. Please check the project ID')

			logger.exit('')
			throw new Error('Unable to validate the linked project. Please check the project ID')
		}

		spinner.succeed(
			` Linked project validated successfully. Linking to project ${chalk.green(
				linkedProject.documentationProject?.name,
			)} with ID ${chalk.green(linkedProject.documentationProject?.id)}.`,
		)

		return linkedProject.documentationProject
	} catch (error) {
		logger.debug('Error while validating linked project', {
			error,
		})

		spinner.fail(' Unable to validate the linked project. Please check the project ID')

		logger.exit('')
		throw error
	}
}
